<template>
  <div>
    <div class="allProject" v-for="(item,index) in tableData" :key="index">
      <div @click="enterDetail(item)">
        <div class="facialName">
          <div class="facialNext">
            <div class="facialList">
              <img class="facialImg" src="../../assets/icon/me.png" alt="" style="">
              <span>{{item.projectName}}</span>
              <span>{{ item.mobile.replace(item.mobile.substr(3, 4), '****') }}</span>
              <img class="myself" src="../../assets/icon/myself.png" alt="">
            </div>
            <div class="nurseName">护士</div>
          </div>
        </div>
        <div class="outpatient">
          <img class="facialImg" src="../../assets/icon/me.png" alt="">
          <span>客服:</span>
          <span class="outName">{{item.doctorName}}</span>
        </div>
        <div class="outpatient">
          <img class="facialImg" src="../../assets/icon/me.png" alt="">
          <span>现场:</span>
          <span class="outName">{{item.doctorName}}</span>
        </div>
        <div class="outpatient">
          <img class="facialImg" src="../../assets/icon/me.png" alt="">
          <span>助理:</span>
          <span class="outName">{{item.doctorName}}</span>
        </div>
      </div>
      <div class="split_line"></div>
      <div class="concat">
        <div class="contactLine">分配诊室</div>
        <div class="contactWait">确认治疗</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [
        {
          projectName: "张三",
          mobile: '14525878956',
          doctorName: '苏医生'
        },

      ],
    }
  },
  methods: {
    enterDetail(item) { },
  }
}
</script>
<style scoped>
@import "../../assets/css/customer.css";
</style>


// WEBPACK FOOTER //
// src/components/customerReception/customNurse.vue